import {
    // isNull,
    // isEmpty,
    // isNil,
    // forEach,
    // isArray,
    // isUndefined
} from "lodash";

const Mixin = {
    data: function () {
            return {
               
            }
    },
    computed: {
        isDev() {
            return process.env.NODE_ENV !== 'production';
        },
        assetsPath() {
            if(process.env.NODE_ENV == 'production'  && typeof window.VSTOptions !== "undefined"){
                return window.VSTOptions.assets_path;
            }else{
                return '';
            }
        }
    },
    methods: {
        log(message, ...args) {
            if (this.isDev) console.log(message, args);
        },
    }
}
export {
    Mixin
}